/**
 * Decorates the ngFormDirective so that the control group directives
 * get passed a reference to the ngModelCtrl that is used by the input. This is
 * needed to determine if the input is pristine.
 */
import _ from 'lodash';

export default ['$delegate', function ($delegate) {
    const directive = $delegate[0];
    const origControllerCtr = directive.controller;

    directive.controller = ['$scope', '$element', '$attrs', '$injector', function ($scope, $element, $attrs, $injector) {
        Object.setPrototypeOf(this, origControllerCtr.prototype);
        const formElement = $element;
        this._inputModelValidationFns = [];
        this._setPristineFns = [];
        this.hasScrolledToError = false;

        const removeListeners = (validationListener, setPristineListener) => {
            let idx = this._inputModelValidationFns.indexOf(validationListener);
            if (idx >= 0) {
                this._inputModelValidationFns.splice(idx, 1);
            }
            idx = this._setPristineFns.indexOf(setPristineListener);
            if (idx >= 0) {
                this._setPristineFns.splice(idx, 1);
            }
        };

        /**
         * Register a control with a form so that we can mark a form
         * as valid or pristine based on the pristine and validity values
         * of each control.
         *
         * @param {Function} validtyFn : Function to get the validity value of a control
         * @param {Function} setPristineFn : Function to mark a control as pristine
         *
         * @returns {Function}
         */
        this.addModelControl = (validtyFn, setPristineFn) => {
            this._inputModelValidationFns.push(validtyFn);
            this._setPristineFns.push(setPristineFn);
            return _.partial(removeListeners, validtyFn, setPristineFn);
        };

        /**
         * Set all controls registered with a form to pristine
         */
        this.setPristine = () => {
            this.hasScrolledToError = false;
            this._setPristineFns.forEach((setCtrlToPristine) => {
                setCtrlToPristine();
            });
        };

        this.getInputFields = () => {
            return angular.element(formElement).find('[gw-viewmodel-ref]');
        };

        this.getFirstErrorInParentForm = (viewModel) => {
            if (!viewModel.baseVMNode) {
                return undefined;
            }

            const invalidFields = viewModel.baseVMNode.container.aspects.invalidChildProperties;

            return _.find(this.getInputFields(), (candidate) => {
                const viewmodelRef = `.${candidate.attributes.getNamedItem('gw-viewmodel-ref').value}`;
                return _.find(invalidFields, (prop) => {
                    return prop === viewmodelRef;
                }) !== undefined;
            });
        };

        Object.defineProperty(this, 'valid', {
            get: () => {
                return _.every(this._inputModelValidationFns, (validFn) => {
                    return validFn();
                });
            }
        });
        Object.defineProperty(this, 'invalid', {
            get: () => {
                return !this.valid;
            }
        });
        // call the original controller with the correct DI services passed in
        $injector.invoke(origControllerCtr, this, {
            $scope,
            $element,
            $attrs
        });
    }];
    return $delegate;
}];